const Diamond = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" className="shrink-0" aria-hidden>
    <path d="M7 0 L14 7 L7 14 L0 7 Z" fill="#C5A059" />
  </svg>
);

export const Marquee = ({ items, dark = false }) => {
  const row = [...items, ...items];
  return (
    <div
      className={`relative overflow-hidden border-y py-7 sm:py-9 ${dark ? "bg-[#070F1E] border-[#C5A059]/25" : "bg-[#F4EEE3] border-[#0A192F]/15"}`}
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-[marquee_70s_linear_infinite] hover:[animation-play-state:paused]">
        {[0, 1].map((k) => (
          <div key={k} className="flex items-center gap-10 sm:gap-14 pr-10 sm:pr-14" aria-hidden={k === 1}>
            {row.map((t, i) => (
              <span key={`${k}-${i}`} className="flex items-center gap-10 sm:gap-14">
                <span className={`font-display italic whitespace-nowrap text-4xl sm:text-6xl lg:text-7xl ${i % 2 ? "text-transparent [-webkit-text-stroke:1px_#C5A059]" : dark ? "text-[#F4EEE3]" : "text-[#0A192F]"}`}>
                  {t}
                </span>
                <Diamond />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
